import 'es6-promise/auto';
import 'babel-polyfill';
import '@fortawesome/fontawesome-free/css/all.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css'; // eslint-disable-line
import Sticky from 'vue-sticky-directive';
import './vueFilters';
import Vue from 'vue';
import '@aspnet/signalr';
import VeeValidate, { Validator } from 'vee-validate';
import Vuetify from 'vuetify';
import axios from 'axios';
import $ from 'jquery';
import LiquorTree from 'liquor-tree';
import FormMixin from './mixins/FormMixins';
import GlobalMixins from './mixins/GlobalMixins';
import AlertBanner from './patterns/AlertBanner';
import SearchFilter from './patterns/SearchFilter';
import 'bootstrap';
import store from './stateStore';
import './plugins/axios';
window.jQuery = $;
window.$ = $;
window.Vue = Vue;
window.axios = axios;
window.vuexStore = store;

Validator.extend('noSpecialCharacters', {
  getMessage: field => `${field} cannot contain a special character ("?", "!", "#", "$", "%", "/", "\\")`,
  validate: value => !/[!#$%\^\[\]\\\/\\\?]/g.test(value),
});


Vue.config.productionTip = false;
Vue.use(Vuetify, {
  theme: {
    primary: '#252525',
    secondary: '#D2202F',
    accent: '#990101',
  },
});
Vue.use(Sticky);
Vue.use(LiquorTree);
Vue.use(VeeValidate, {
  events: 'change',
});
Vue.mixin(FormMixin);
Vue.mixin(GlobalMixins);
Vue.component('alert-banner', AlertBanner);
Vue.component('search-filter', SearchFilter);

const areaFiles = require.context('~/Views', true, /\.vue$/i);
const resourceFiles = require.context('~/Resources', true, /\.vue$/i);

// eslint-disable-next-line
areaFiles.keys().map((key) => {
  const component = areaFiles(key).default;
  if (component.parent) {
    Vue.component(key.split('/').pop().split('.')[0], areaFiles(key).default);
  }
});

// eslint-disable-next-line
resourceFiles.keys().map((key) => {
  const component = resourceFiles(key).default;
  if (component.parent) {
    Vue.component(key.split('/').pop().split('.')[0], resourceFiles(key).default);
  }
});